import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box, CheckboxButton, PlacementTitle } from './SettingsStyled';

import { useWindowWide } from '../../helpers/wideScreen';

import { useTranslation } from 'react-i18next';
import Spinner from '../../components/common/Spinner';
import { Flexed, PageTitle } from '../../styles/GlobalComponents';
import { colors } from '../../styles/GlobalStyles';
import {
  Icon,
  IconEdit,
  IconSettingsCheckboxOff,
  IconSettingsCheckboxOn,
  IconTeamLeft,
  IconTeamRight
} from '../../styles/Icons';
import { updateTeamSettings } from './Settings.actions';
import { useAppSelector } from '../../app/hooks';
import { P1, P2 } from '../../styles/FontStyles';
import { Button } from '../../components';

export const TeamSettings = () => {
  const { t } = useTranslation('settings');
  const dispatch = useDispatch();
  const { teamSettings, loading } = useAppSelector((state) => state.settings);

  const [selected, setSelected] = useState(teamSettings);

  const wide = useWindowWide(800);

  return (
    <>
      {loading ? (
        <Spinner fullScreen={true} />
      ) : (
        <>
          <Box style={{ width: wide ? 336 : '' }}>
            <P2 bold mb='16'>
              {t('team.default_placement')}
            </P2>

            <CheckboxButton
              checked={selected === 1}
              onClick={() => setSelected(1)}>
              <div>
                <Flexed justifyCenter center>
                  {' '}
                  <Icon mr='10'>
                    {' '}
                    <IconTeamLeft />
                  </Icon>
                  {t('team.left_bottom')}
                </Flexed>
              </div>
            </CheckboxButton>

            <CheckboxButton
              checked={selected === 2}
              onClick={() => setSelected(2)}>
              <div>
                <Flexed justifyCenter center>
                  {' '}
                  <Icon mr='10'>
                    {' '}
                    <IconTeamRight />
                  </Icon>
                  {t('team.right_bottom')}
                </Flexed>
              </div>
            </CheckboxButton>

            <CheckboxButton
              checked={selected === 3}
              onClick={() => setSelected(3)}>
              <div>{t('team.weaker_team')}</div>
            </CheckboxButton>

            <Button
              m='12px 0 0 0'
              onClick={() => dispatch(updateTeamSettings(selected || 0))}>
              {t('team.save_changes')}
            </Button>
          </Box>
        </>
      )}
    </>
  );
};
